module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent-fm5"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v("I am the last of the novelists for a long time now.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-fm6"
  }, [_vm._v("There never was a good biography of a good novelist. There couldn’t be. He is too many people if he’s any good.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-fm6"
  }, [_vm._v("Biography is the falsest of the arts. That is because there were no Keatzians before Keats, no Lincolnians before Lincoln.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-fm6"
  }, [_vm._v("I left my capacity for hoping on the little roads that led to Zelda’s sanitarium.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-fm6"
  }, [_vm._v("The voices fainter and fainter—How is Zelda, how is Zelda—tell us—how is Zelda.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-fm6"
  }, [_vm._v("Genius is the ability to put into effect what is in your mind. There’s no other definition of it.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-fm6"
  }, [_vm._v("I look out at it—and I think it is the most beautiful history in the world. It is the history of me and of my people. And if I came here yesterday like Sheilah I should still think so. It is the history of all aspiration—not just the American dream but the human dream and if I came at the end of it that too is a place in the line of pioneers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-fm6"
  }, [_vm._v("Then I was drunk for many years, and then I died.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-fm7"
  }, [_vm._v("—From the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Notebooks")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bdedffc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Fm02.vue
// module id = 72
// module chunks = 0